module.exports = __webpack_public_path__ + "media/cement.5eb935ea.svg";